import ApiFactory from './factory'
import declaration from './declarations'
import localSave from '@utils/local-save'

const currentUser = localSave.get('auth.currentUser')
const token = (currentUser && currentUser.token) || null

const Api = new ApiFactory(process.env.VUE_APP_API_BASE_URL + 'v3', declaration, token)

export default Api
